/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Shared_MonthsInputs */

const en_shared_months = /** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} month`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} months`);
	return /** @type {LocalizedString} */ ("shared.months");
};

const de_shared_months = /** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} Monat`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} Monate`);
	return /** @type {LocalizedString} */ ("shared.months");
};

const es_shared_months = /** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} mes`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} meses`);
	return /** @type {LocalizedString} */ ("shared.months");
};

const fr_shared_months = /** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} mois`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} mois`);
	return /** @type {LocalizedString} */ ("shared.months");
};

const nl_shared_months = /** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural == "one") return /** @type {LocalizedString} */ (`${i?.count} maand`);
	if (countPlural == "other") return /** @type {LocalizedString} */ (`${i?.count} maanden`);
	return /** @type {LocalizedString} */ ("shared.months");
};

/** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */
const it_shared_months = en_shared_months;

/** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */
const pt_br2_shared_months = en_shared_months;

/** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */
const pl_shared_months = en_shared_months;

/** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */
const hu_shared_months = en_shared_months;

/** @type {(inputs: Shared_MonthsInputs) => LocalizedString} */
const ro_shared_months = en_shared_months;

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} month" |
* | "other" | "{count} months" |
*
* @param {Shared_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_months = /** @type {((inputs: Shared_MonthsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_MonthsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_months(inputs)
	if (locale === "de") return de_shared_months(inputs)
	if (locale === "es") return es_shared_months(inputs)
	if (locale === "fr") return fr_shared_months(inputs)
	if (locale === "nl") return nl_shared_months(inputs)
	if (locale === "it") return it_shared_months(inputs)
	if (locale === "pt-BR") return pt_br2_shared_months(inputs)
	if (locale === "pl") return pl_shared_months(inputs)
	if (locale === "hu") return hu_shared_months(inputs)
	return ro_shared_months(inputs)
});
export { shared_months as "shared.months" }